import { serviceToInvoiceableEntity } from "components/Invoicing/invoiceAdapter";
import InvoiceContainer from "components/Invoicing/InvoiceContainer";
import LoadingIcon from "components/Loading/LoadingIcon";
import TaskModal from "pages/tasks/components/modals/TaskModal";
import { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import { clearCurrentTask } from "reducers/files";
import { setShowTaskModal } from "reducers/main";
import { useGetDocumentsQuery } from "services/documents-api";
import { useGetFileByIdQuery } from "services/file-api";
import { useGetMiscServiceByIdQuery } from "services/misc-api";
import { useDispatch, useSelector } from "utils/redux";

import ConsultingAssignmentForm from "./ConsultingAssignmentForm";
import ConsultingDocumentsList from "./ConsultingDocumentsList";
import ConsultingNotesForm from "./ConsultingNotesForm";
import ConsultingPageContainer from "./ConsultingPageContainer";

const ConsultingPage = () => {
  const dispatch = useDispatch();
  const { miscServiceId } = useParams<{ miscServiceId: string }>();
  const showTaskModal = useSelector((state) => state.main.showTaskModal);

  const { data: service, isLoading } = useGetMiscServiceByIdQuery(
    {
      id: miscServiceId,
    },
    { skip: !miscServiceId },
  );

  const { data: fileData } = useGetFileByIdQuery(
    {
      id: service?.file?.id?.toString(),
    },
    { skip: !service?.file?.id },
  );

  const { data: documents = [] } = useGetDocumentsQuery(
    {
      fileId: fileData?.id?.toString(),
    },
    { skip: !fileData?.id },
  );

  const handleClose = useCallback(() => {
    dispatch(clearCurrentTask());
    dispatch(setShowTaskModal(false));
  }, [dispatch]);

  const invoiceableEntity = useMemo(() => {
    if (!service) return null;
    return serviceToInvoiceableEntity(service);
  }, [service]);

  if (isLoading || !service || !fileData) {
    return <LoadingIcon />;
  }

  const leftPanelContent = (
    <>
      <ConsultingAssignmentForm service={service} file={fileData} />
      {invoiceableEntity && (
        <InvoiceContainer
          entity={invoiceableEntity}
          applySwimColumnClass={false}
        />
      )}
    </>
  );

  const rightPanelContent = (
    <>
      <ConsultingNotesForm service={service} />
      <ConsultingDocumentsList
        documents={Array.isArray(documents) ? documents : documents.results}
      />
    </>
  );

  return (
    <>
      <ConsultingPageContainer
        layout="split"
        fileId={fileData?.id?.toString()}
        serviceId={service?.id?.toString()}
        serviceType={service?.type}
        childrenLeft={leftPanelContent}
        childrenRight={rightPanelContent}
      />
      {showTaskModal && (
        <TaskModal
          isOpen={showTaskModal}
          onClose={handleClose}
          fileId={fileData?.id?.toString()}
          serviceId={service?.service.id}
        />
      )}
    </>
  );
};

export default ConsultingPage;
